module.exports = __webpack_public_path__ + "img/feature.fbb1002a.png";